import { render, staticRenderFns } from "./TagFilterV2.vue?vue&type=template&id=07336f1b&scoped=true"
import script from "./TagFilterV2.vue?vue&type=script&lang=js"
export * from "./TagFilterV2.vue?vue&type=script&lang=js"
import style0 from "./TagFilterV2.vue?vue&type=style&index=0&id=07336f1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07336f1b",
  null
  
)

export default component.exports